import { ACTION_GET_PREMIUM_FEATURE_ACTIVE } from "@/core/models/connector";
import connectorService from "@/core/services/api/connector.service";

const PREMIUM_FEATURES_STORAGE_KEY = "cx-enabled-premium-features";

export const premiumFeaturesFromConnectorService = {
  /**
   * @returns {array|null}
   */
  getEnabledConnectorPremiumFeatures() {
    const storedPF = window.localStorage.getItem(PREMIUM_FEATURES_STORAGE_KEY);

    if (storedPF) {
      const premiumFeatures = JSON.parse(storedPF);
      if (premiumFeatures?.length) {
        return premiumFeatures;
      }
    }

    return [];
  },

  /**
   * @returns {Promise<void>}
   */
  async fetchAndSaveEnabledConnectorPremiumFeatures() {
    const premiumFeatures = await connectorService.launchPremiumFeatureConnector(ACTION_GET_PREMIUM_FEATURE_ACTIVE);
    window.localStorage.setItem(PREMIUM_FEATURES_STORAGE_KEY, JSON.stringify(premiumFeatures));
  },

  /**
   * @returns {void}
   */
  removeEnabledConnectorPremiumFeaturesLocally() {
    window.localStorage.removeItem(PREMIUM_FEATURES_STORAGE_KEY);
  },
};
